export const useStyles = ({ colors }) => ({
  whiteBox: {
    backgroundColor: colors.hexaWhite,
    minHeight: ({ height }) => height || "304px",
    height: "auto",
    padding: "2rem 0",
  },
});
